import { type GameDefinition } from '@kite/engine';
import { chaseCarGame } from '@tiny-play/game-chase-car';

/**
 * Every game the portal can launch.
 *
 * Adding a game means creating its package and adding one line here. No engine or portal internals
 * change, which is the whole point of the registry: the portal knows the list, the engine knows the
 * contract, and a game knows neither.
 */
export const GAME_REGISTRY: readonly GameDefinition[] = [chaseCarGame];

/** Looks a game up by id, or returns undefined when the id is unknown. */
export function findGame(id: string): GameDefinition | undefined {
  return GAME_REGISTRY.find((game) => game.id === id);
}
